import {IBaseLookup} from "./Ibase.lookup";

export namespace ExtraCode {

    export const lookupName: string = "ExtraCode";

    export interface ExtraCode {
        extraCodeKey: number;
        code: string;
        description: string;
        active: string;
        lastUpdated: Date;
    }

    export interface ExtraCodeDS extends IBaseLookup {
        extraCode: ExtraCode[];
    }
}
